import { render, staticRenderFns } from "./MarketingUpgradePage.vue?vue&type=template&id=6d37585e&scoped=true"
import script from "./MarketingUpgradePage.vue?vue&type=script&lang=js"
export * from "./MarketingUpgradePage.vue?vue&type=script&lang=js"
import style0 from "./MarketingUpgradePage.vue?vue&type=style&index=0&id=6d37585e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37585e",
  null
  
)

export default component.exports